import request from '../request.js'
// 保存/修改（张卫华）
const saveOrUpdate = function (data) {
    return request({
        url: 'sysTenantLimit/saveOrUpdate',
        method: 'post',
        data
    })
}
// 获取租户对应主体信息（张卫华）
const getTenantSubject = function (data) {
    return request({
        url: 'sysTenantLimit/getTenantSubject',
        method: 'post',
        data
    })
}
export {
    saveOrUpdate,
    getTenantSubject,
}